import { Section, SectionContent } from '../../../../components/Section';
import { ReactNode } from 'react';

interface Props {
  description?: string;
  icon?: ReactNode;
  title: string;
  level?: 'main' | 'sub';
  children: ReactNode;
}

export const SettingRow = ({
  children,
  description,
  icon = null,
  level = 'main',
  title,
}: Props) => {
  const classes = useStyles();

  const renderIcon = () => {
    if (!icon) return;
    return icon;
  };

  const renderDescription = () => {
    if (description === undefined) return;
    return <p className={classes.description}>{description}</p>;
  };

  return (
    <Section className={classes.container} margin="none" fullWidth>
      <SectionContent className="!w-full" padding="none">
        <div className={classes.content}>
          <div className={classes.headerContainer}>
            {renderIcon()}
            <div className={classes.header}>
              <p className={classes.title[level]}>{title}</p>
              {renderDescription()}
            </div>
          </div>
          {children}
        </div>
      </SectionContent>
    </Section>
  );
};

const useStyles = () => ({
  container: 'py-1',
  description: 'text-[0.75rem] opacity-70',
  header: 'flex flex-col items-start whitespace-nowrap',
  headerContainer: 'flex flex-row items-center gap-2 px-1',
  content:
    'inline-flex flex-wrap lg:flex-nowrap justify-between items-center gap-2 w-full',
  title: {
    sub: 'text-md',
    main: 'text-lg',
  },
});
